// Add 'for research' checkbox before checkout button

(function() {
  function buildDisclaimerNode() {
    var wrapper = document.createElement('div');
    wrapper.className = 'research-disclaimer';
    var label = document.createElement('label');
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.id = 'research-agree';
    label.appendChild(input);
    label.appendChild(document.createTextNode(' I understand that I am purchasing for research purposes only and I am 18+ years old.'));
    wrapper.appendChild(label);
    return wrapper;
  }

  function injectStylesOnce() {
    if (document.getElementById('research-disclaimer-styles')) return;
    var s = document.createElement('style');
    s.id = 'research-disclaimer-styles';
    s.type = 'text/css';
    s.appendChild(document.createTextNode(
      '.research-disclaimer{margin-bottom:15px;padding:10px;background-color:#f9f9f9;border:1px solid #ddd;border-radius:6px;font-size:14px;}' +
      '.research-disclaimer label{display:flex;align-items:center;cursor:pointer;}' +
      '.research-disclaimer input[type="checkbox"]{transform:scale(1.2);margin-right:8px;}'
    ));
    document.head.appendChild(s);
  }

  function insertDisclaimerIfNeeded(target) {
    var ctas = target.querySelector('.cart__ctas');
    if (!ctas || target.querySelector('.research-disclaimer')) return;
    injectStylesOnce();
    var node = buildDisclaimerNode();
    ctas.parentNode.insertBefore(node, ctas);
  }

  // Observe the entire body for new nodes (covers AJAX cart drawer)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      for (var i = 0; i < m.addedNodes.length; i++) {
        var node = m.addedNodes[i];
        if (node.nodeType === 1) { // ELEMENT_NODE
          insertDisclaimerIfNeeded(node);
          // Also check children in case .cart__ctas is nested
          var nested = node.querySelectorAll('.cart__ctas');
          for (var j = 0; j < nested.length; j++) {
            insertDisclaimerIfNeeded(nested[j].parentNode);
          }
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Delegated click guard for checkout buttons in cart drawer or page
  document.addEventListener('click', function(e) {
    var el = e.target;
    while (el && el !== document) {
      if (el.id === 'checkout' || (el.classList && el.classList.contains('cart__checkout-button'))) {
        var checkbox = document.getElementById('research-agree');
        if (!checkbox || !checkbox.checked) {
          e.preventDefault();
          e.stopPropagation && e.stopPropagation();
          alert('Please agree to purchasing for research purposes only and confirm you are 18+ before making a purchase.');
        }
        return;
      }
      el = el.parentNode;
    }
  }, true);
})();






function hideInStockText() {
  const spans = document.querySelectorAll(
    '.product__info-wrapper p.product__inventory span.inventory-info'
  );

  spans.forEach(function (span) {
    if (span.textContent.trim().includes('In stock')) {
      span.style.display = 'none';
    }
  });
}

document.addEventListener('DOMContentLoaded', hideInStockText);
document.addEventListener('shopify:section:load', hideInStockText);

// Optional: watch for dynamic changes
const observer = new MutationObserver(hideInStockText);
observer.observe(document.body, { childList: true, subtree: true });